const ENTITY_NAME = "Assignment unit";
const PAGE_TITLES = {
  create: `Create an assignment unit`,
  list: `Manage assignment units`,
  view: "View assignment unit"
};
const reduxActionTypePrefix = `assignment-unit-app-module`;
export {
  ENTITY_NAME,
  PAGE_TITLES,
  reduxActionTypePrefix
};
//# sourceMappingURL=module.constants.js.map
